// Inline SVG placeholder — avoids depending on an external network call for
// an image, both in fixture data and as the "no preview" fallback shown for
// real extensions that haven't committed a preview.png yet.
export const placeholderImage = (label: string): string =>
  `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="480" height="270">` +
      `<rect width="100%" height="100%" fill="#e0e0e0"/>` +
      `<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" ` +
      `font-family="sans-serif" font-size="20" fill="#616161">${label}</text>` +
      `</svg>`,
  )}`;
